/**
 * Ashore API
 * Hand-written client for the approver-group endpoints, following the
 * generated OpenAPI client conventions (see ApproverApi.js).
 */

import ApiClient from "../ApiClient";
import SuccessResponse from '../model/SuccessResponse';

/**
* ApproverGroup service.
* @module api/ApproverGroupApi
* @version V1
*/
export default class ApproverGroupApi {

    /**
    * Constructs a new ApproverGroupApi.
    * @alias module:api/ApproverGroupApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Get all approver groups for the current account, each with its member approver ids.
     */
    getAll(callback) {
      let postBody = null;

      let pathParams = {};
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = [Object];
      return this.apiClient.callApi(
        '/approver-group/all', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {Object} [opts.saveApproverGroupRequest] {name, approverIds}
     */
    createApproverGroup(opts, callback) {
      opts = opts || {};
      let postBody = opts['saveApproverGroupRequest'];

      let pathParams = {};
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/approver-group', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * @param {Number} id
     * @param {Object} opts Optional parameters
     * @param {Object} [opts.saveApproverGroupRequest] {name, approverIds}
     */
    updateApproverGroup(id, opts, callback) {
      opts = opts || {};
      let postBody = opts['saveApproverGroupRequest'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateApproverGroup");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['AccessToken'];
      let contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = Object;
      return this.apiClient.callApi(
        '/approver-group/{id}', 'PATCH',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * @param {Number} id
     */
    deleteApproverGroup(id, callback) {
      let postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteApproverGroup");
      }

      let pathParams = {
        'id': id
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['AccessToken'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = SuccessResponse;
      return this.apiClient.callApi(
        '/approver-group/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }
}
